import React, { useEffect, useState, useRef, useCallback } from "react";
import edit from "../../Assets/svg/edit.svg";
import dt from "../../Assets/svg/delete.svg";
import lar from "../../Assets/svg/lar.svg";
import rar from "../../Assets/svg/rar.svg";
import cancel from "../../Assets/svg/cancel.svg";
import uploadIcon from "../../Assets/svg/upload-icon.svg";
import downloadIcon from "../../Assets/svg/download-icon.svg";
import Modal from "@mui/material/Modal";
import { Container, Row, Col, Toast, ToastContainer, Spinner } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import SearchWithAPI from "../common/searchbox/searchbox.js";
import { useGlobal } from "../../GlobalContext.js";
import { apiCall } from "../../services/api-service.js";
import DeleteModal from "../common/DeleteModal";
import { useExcelActions } from "../../hooks/useExcelActions";
import ReportButton from "../common/ReportButton.jsx";

const Teamlist = () => {
  const { rolePermissionList } = useGlobal();
  const fileInputRef = useRef(null);


  const [loading, setLoading] = useState(false);
  const [teamId, setTeamId] = useState(-1);
  const [open, setOpen] = React.useState(false);
  const [validations, setValidations] = useState({
    name: "",
    members: "",
  });

  function checkPermission(menuName, permission) {
    return rolePermissionList.some(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    );
  }

  const handleClose = () => {
    setTeamId(-1);
    setValidations({
      name: "",
      members: "",
    });
    setTeamName("");
    setTeamMembers([]);
    setTeamMemberOption(null);
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };


  const [teamName, setTeamName] = useState("");
  const [selectedTeamMemberOption, setTeamMemberOption] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const handleTeamMemberDropdownChange = (option) => {
    setTeamMemberOption(option);
  };

  const [teamList, setTeamList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10); // or any default value
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);


  const getListData = async (term, skip = itemOffset) => {
    setLoading(true);
    const response = await apiCall("get", "team", null, {
      params: {
        limit: itemsPerPage,
        skip,
        search: term,
        status,
      },
    });
    if (response?.status === 200 && response.data?.success === true) {
      const totalPages = response.data.total_pgs ?? 0;
      setTotalCount(response.data.total_rec ?? 0);
      setPageCount(totalPages);
      setTeamList(response.data.teams ?? []);

      // If the current page is now beyond the available pages (e.g. after a
      // delete/filter shrinks the result set), snap back to the last page.
      const currentPage = Math.floor(skip / itemsPerPage);
      if (currentPage > totalPages) {
        setItemOffset(totalPages * itemsPerPage);
      }
    }
    setLoading(false);
  };

  const {
    uploadLoading,
    templateLoading,
    reportLoading,
    handleFileUpload,
    downloadTemplate,
    downloadReport,
    handleDragOver,
    handleDragEnter,
    handleDragLeave,
    handleDrop,
    isDragging,
  } = useExcelActions("team", getListData, {
    setSnackbarMessage,
    setSnackbarStatus,
    handleSnackbarShow,
  }, "teams");

  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [status, setStatus] = useState("All");

  useEffect(() => {
    getListData(searchTerm);
  }, [status, itemsPerPage, itemOffset]);
  /* const pageCount = Math.ceil(teamList.length / itemsPerPage); */

  const handlePageClick = useCallback(
    (event) => {
      const newOffset = event.selected * itemsPerPage;
      setItemOffset(newOffset); // Not event.selected
    },
    [itemsPerPage]
  );
  const [deleteId, setDeleteId] = useState(null);
  const deleteTeam = async (id) => {
    setDeleteId(id);
    setIsOpenDelete(true);
  };
  const deleteApi = async () => {
    if (deleteId != null) {
      setLoading(true);
      const response = await apiCall("delete", `team/${deleteId}`);
      if (response?.status === 200 && response.data?.success === true) {
        setDeleteId(null);
        setIsOpenDelete(false);
        await getListData("");
      } else {
        setLoading(false);
      }
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(response?.data?.success === true);
      handleSnackbarShow();
    }
  };
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const handleSearch = debounce((term) => {
    // A new search starts from the first page. If already on page 1, fetch
    // directly; otherwise just reset the offset and let the itemOffset effect
    // fetch (this avoids issuing the request twice).
    if (itemOffset === 0) {
      getListData(term, 0);
    } else {
      setItemOffset(0);
    }
  }, 1000);

  const handleStatusChange = async (id, currentVal) => {
    setLoading(true);
    const newVal = currentVal === "Active" ? true : false;
    const response = await apiCall("put", `team_status_update/${id}`, {
      status: newVal,
    });
    if (response?.status === 200 && response.data?.success === true) {
      await getListData(searchTerm);
    } else {
      setLoading(false);
    }
    setSnackbarMessage(response?.data?.message ?? "Something went wrong");
    setSnackbarStatus(response?.data?.success === true);
    handleSnackbarShow();
  };

  const applyValidationErrors = (errorObj = {}) => {
    const validationTemp = { name: "", members: "" };
    Object.entries(errorObj).forEach(([key, value]) => {
      validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : "";
    });
    setValidations(validationTemp);
  };

  const teamSubmit = async () => {
    setValidations({ name: "", members: "" });
    setLoading(true);
    const requestBody = {
      name: teamName,
      members: teamMembers.map((item) => item.value),
    };
    const isNew = teamId === null || teamId === undefined || teamId === -1;
    const response = await apiCall(
      isNew ? "post" : "put",
      isNew ? "team" : `team/${teamId}`,
      requestBody
    );
    if (response?.status === 200 && response.data?.success === true) {
      handleClose();
      await getListData("");
    } else {
      setLoading(false);
      if (response?.data?.error) {
        applyValidationErrors(response.data.error);
      }
    }
  };
  const teamEdit = async (id) => {
    setLoading(true);
    const response = await apiCall("get", `team/${id}`);
    if (response?.status === 200 && response.data?.success === true) {
      handleOpen();
      setTeamId(id);
      setTeamName(response.data.team.name);
      setTeamMembers(response.data.team.members ?? []);
    }
    setLoading(false);
  };
  return (
    <Container fluid style={{ width: "100%", padding: "0px" }}>
      <div className="d-flex side4">
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            // // height: "100vh",
            overflow: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <div className="maincontent3">
              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ gap: "12px" }}>
                  <div>
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "20px",
                        lineHeight: "22px",
                        color: "#212129",
                      }}
                    >
                      Teams
                    </span>
                    <div
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "22px",
                        color: "#8790A1",
                      }}
                    >
                      Manage your teams and team members list here
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                  <div
                    onClick={() => !uploadLoading && fileInputRef.current.click()}
                    onDragOver={handleDragOver}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    style={{
                      height: "40px",
                      borderRadius: "100px",
                      padding: "8px 16px",
                      gap: "8px",
                      backgroundColor: isDragging ? "#F0E9FF" : "#FFFFFF",
                      border: isDragging ? "2px dashed #6929E2" : "1px solid #E5E5E5",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: uploadLoading ? "not-allowed" : "pointer",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileUpload}
                      accept=".xlsx, .xls"
                      style={{ display: "none" }}
                    />
                    {uploadLoading ? (
                      <div className="spinner"></div>
                    ) : (
                      <img
                        src={uploadIcon}
                        alt="excel"
                        style={{ width: "16px", height: "16px" }}
                      />
                    )}
                    <p
                      style={{
                        margin: "0",
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "14px",
                        lineHeight: "18.9px",
                        color: "#212129",
                      }}
                    >
                      Upload
                    </p>
                  </div>

                  <div
                    onClick={downloadTemplate}
                    style={{
                      height: "40px",
                      borderRadius: "100px",
                      padding: "8px 16px",
                      gap: "8px",
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #E5E5E5",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    {templateLoading ? (
                      <div className="spinner"></div>
                    ) : (
                      <img
                        src={downloadIcon}
                        alt="template"
                        style={{ width: "16px", height: "16px" }}
                      />
                    )}
                    <p
                      style={{
                        margin: "0",
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "14px",
                        lineHeight: "18.9px",
                        color: "#212129",
                      }}
                    >
                      Template
                    </p>
                  </div>
                  {checkPermission("Team", "create_permission") && (
                    <button
                      style={{
                        height: "40px",
                        borderRadius: "100px",
                        padding: "8px 16px 8px 16px",
                        gap: "8px",
                        backgroundColor: "#6929E2",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: "none",
                      }}
                      onClick={handleOpen}
                    >
                      <p
                        style={{
                          margin: "0",
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "14px",
                          lineHeight: "18.9px",
                          color: "#FFFFFF",
                        }}
                      >
                        + New Team
                      </p>
                    </button>
                  )}
                </div>

                <Modal
                  onClose={handleClose}
                  open={open}
                  BackdropProps={{ onClick: (e) => e.stopPropagation() }}
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    top: "0px",
                    left: "0px",
                  }}
                >
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "transparent",
                      opacity: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 1000,
                    }}
                  >
                    <div
                      style={{
                        width: "520px",
                        overflowY: "auto",
                        borderRadius: "16px",
                        padding: "24px",
                        gap: "16px",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <div
                        style={{
                          gap: "24px",
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "16px",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "20px",
                              lineHeight: "27px",
                              color: "#212129",
                              display: "block",
                            }}
                          >
                            Add Team
                          </span>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "400",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#8790A1",
                            }}
                          >
                            Enter below details to create new team
                          </span>
                        </div>
                        <div style={{ cursor: "pointer" }}>
                          <img src={cancel} alt="" onClick={handleClose} />
                        </div>
                      </div>

                      <div style={{ marginBottom: "16px" }}>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            marginBottom: "8px",
                            color: "#212129",
                            display: "block",
                          }}
                        >
                          Team Name<span style={{ color: "red" }}> *</span>
                        </span>
                        <input
                          type="text"
                          value={teamName}
                          onChange={(event) => {
                            setTeamName(event.target.value);
                          }}
                          style={{
                            borderRadius: "10px",
                            border: "1.4px solid #6929E2",
                            padding: "16px",
                            gap: "77px",
                            backgroundColor: "#FFFFFF",
                            height: "44px",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#21272C",
                          }}
                          className="col-12"
                        />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validations.name}
                        </span>
                      </div>

                      <div style={{ marginBottom: "16px" }}>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            marginBottom: "8px",
                            color: "#212129",
                            display: "block",
                          }}
                        >
                          Team members
                        </span>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            width: "100%",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <SearchWithAPI
                              onDropdownChange={handleTeamMemberDropdownChange}
                              apiUrl={`get_employee`}
                              placeholder={"Enter name here..."}
                              selectedOption={selectedTeamMemberOption}
                              selectedOptions={teamMembers}
                            />
                          </div>
                          <div
                            onClick={() => {
                              if (selectedTeamMemberOption != null) {
                                const index = teamMembers.findIndex(
                                  (option) =>
                                    option.value ===
                                    selectedTeamMemberOption.value
                                );
                                if (index === -1) {
                                  setTeamMembers([
                                    ...teamMembers,
                                    selectedTeamMemberOption,
                                  ]);
                                  setTeamMemberOption(null);
                                }
                              }
                            }}
                            style={{
                              cursor: "pointer",
                              padding: "10px 15px",
                              backgroundColor: "#D4DBFF",
                              borderRadius: "8px",
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Add
                          </div>
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validations.members}
                        </span>
                      </div>

                      <div style={{ marginBottom: "16px" }}>
                        <div>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "12px",
                              lineHeight: "16.2px",
                              color: "#6929E2",
                            }}
                          >
                            Added members : {teamMembers.length}{" "}
                          </span>
                          <div style={{ height: "150px", overflowY: "auto" }}>
                            {" "}
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "8px",
                              }}
                            >
                              {teamMembers.map((item, index) => (
                                <div
                                  key={`${index}-email`}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    borderRadius: "8px",
                                    padding: "4px 8px 4px 8px",
                                    gap: "8px",
                                    backgroundColor: "#F5F7F9",
                                    marginRight: "8px",
                                  }}
                                >
                                  <div>
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "12px",
                                        lineHeight: "20px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      {item.label}
                                    </span>
                                  </div>
                                  <img
                                    onClick={() => {
                                      const updatedItems = [...teamMembers];
                                      updatedItems.splice(index, 1);
                                      setTeamMembers(updatedItems);
                                    }}
                                    src={cancel}
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="col-4"></div>

                        <div
                          onClick={handleClose}
                          style={{
                            borderRadius: "100px",
                            border: "0.6px solid #E5E5E5",
                            padding: "10px 28px 10px 28px",
                            backgroundColor: "#FFFFFF",
                            cursor: "pointer",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#21272C",
                              cursor: "pointer",
                            }}
                          >
                            Cancel
                          </span>
                        </div>

                        <div
                          onClick={() => {
                            teamSubmit();
                          }}
                          style={{
                            borderRadius: "100px",
                            border: "0.6px solid #E5E5E5",
                            padding: "10px 28px 10px 28px",
                            backgroundColor: "#3253EB",
                            cursor: "pointer",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#FFFFFF",
                            }}
                          >
                            Save
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: "16px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "14px",
                      lineHeight: "22px",
                      color: "#212129",
                      margin: "0",
                    }}
                  >
                    Total teams: {totalCount}
                  </p>
                </div>

                <div
                  style={{
                    height: "40px",
                    gap: "12px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: "16px",
                  }}
                >
                  <div>
                    <input
                      type="search"
                      placeholder="Search..."
                      onChange={(event) => {
                        setSearchTerm(event.target.value);
                        handleSearch(event.target.value);
                      }}
                      style={{
                        width: "300px",
                        height: "40px",
                        borderRadius: "100px",
                        border: "0.5px solid #E5E5E5",
                        padding: "14px 16px 14px 16px",
                        gap: "6px",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                  </div>

                  <div>
                    <select
                      value={status}
                      onChange={(event) => {
                        setStatus(event.target.value);
                      }}
                      style={{
                        width: "127px",
                        height: "40px",
                        borderRadius: "100px",
                        border: "1.4px solid #6929E2",
                        backgroundColor: "#FFFFFF",
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "13px",
                        lineHeight: "17.55px",
                        color: "#6929E2",
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        paddingTop: "11px",
                        paddingBottom: "11px",
                        cursor: "pointer",
                      }}
                    >
                      <option value="All">All</option>
                      <option value="Active">Active</option>
                      <option value="InActive">InActive</option>
                    </select>
                  </div>
                  <ReportButton
                    loading={reportLoading}
                    onClick={() => downloadReport({ status, search: searchTerm })}
                  />
                </div>
              </div>

              <div
                style={{
                  borderRadius: "8px",
                  paddingTop: "16px",
                  paddingBottom: "16px",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <div
                  style={{
                    height: "42px",
                    flex: "10",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px 12px 16px",
                    backgroundColor: "#F2F2F2",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "3",
                    }}
                  >
                    Team Name
                  </span>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "5",
                    }}
                  >
                   Team Members
                  </span>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "2",
                    }}
                  >
                    Status
                  </span>
                </div>
                <div>
                  {teamList.map((item, index) => (
                    <div
                      key={"table-list" + index}
                      style={{ position: "relative", cursor: "pointer" }}
                    >
                      <div
                        style={{
                          height: "40px",
                          flex: "10",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "6px 16px 6px 16px",
                          backgroundColor: "#FFFFFF",
                          borderBottom: "0.6px solid #D4DDE7",
                        }}
                      >
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#212129",
                            flex: "3",
                          }}
                        >
                          {item.name}
                        </span>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#212129",
                            flex: "5",
                            display: "-webkit-box",
                            WebkitLineClamp: 2, // max 5 lines
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden", // hide overflow
                            textOverflow: "ellipsis", // show "..." if text is too long
                          }}
                          title={item.users} // tooltip shows full text
                        >
                          {item.users}
                        </span>

                        <div style={{ flex: "2" }}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div
                              style={{
                                width: "8px",
                                height: "8px",
                                borderRadius: "3px",
                                backgroundColor:
                                  item.status === true ? "#5DCB8C" : "#FA8888",
                                marginRight: "5.5px",
                              }}
                            ></div>
                            <select
                              value={item.status === true ? "Active" : "InActive"}
                              onChange={(e) => handleStatusChange(item.id, e.target.value)}
                              style={{ border: "none", marginRight: "80px", cursor: "pointer" }}
                            >
                              <option value="Active">Active</option>
                              <option value="InActive">InActive</option>
                            </select>

                            {checkPermission("Team", "edit_permission") && (
                              <div
                                onClick={() => {
                                  teamEdit(item.id);
                                }}
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100px",
                                  gap: "10px",
                                  backgroundColor: "#FFFFFF",
                                }}
                              >
                                <img
                                  src={edit}
                                  style={{ width: "14px", height: "14px" }}
                                />
                              </div>
                            )}

                            {checkPermission("Team", "delete_permission") && (
                              <div
                                onClick={() => {
                                  deleteTeam(item.id);
                                }}
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100px",
                                  gap: "10px",
                                  backgroundColor: "#FFFFFF",
                                }}
                              >
                                <img
                                  src={dt}
                                  style={{ width: "14px", height: "14px" }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0 16px",
                    gap: "12px",
                  }}
                >
                  {/* Items per page — bottom left */}
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#8790A1",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Items per page
                    </span>
                    <select
                      className="select3"
                      id="perpage"
                      value={itemsPerPage}
                      onChange={(event) => {
                        setItemsPerPage(Number(event.target.value));
                        setItemOffset(0);
                      }}
                      style={{
                        cursor: "pointer",
                        fontFamily: "Satoshi",
                        fontSize: "14px",
                        fontWeight: "500",
                        lineHeight: "18.9px",
                        color: "#8790A1",
                        height: "36px",
                        borderRadius: "10px",
                        border: "0.7px solid #E5E5E5",
                        padding: "0 8px",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>

                  {/* Pagination — bottom right */}
                  <ReactPaginate
                    previousLabel={
                      <img src={lar} className="ar3" alt="previous" />
                    }
                    nextLabel={<img src={rar} className="ar3" alt="next" />}
                    breakLabel={"..."}
                    pageCount={pageCount + 1}
                    forcePage={Math.min(
                      Math.floor(itemOffset / itemsPerPage),
                      pageCount
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <DeleteModal
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={deleteApi}
        title="Delete Team"
        message="You won’t able to access your team after deleting. Are you sure want to delete?"
      />
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          {/*  <Toast.Header>
                                <strong className="mr-auto">Snackbar Title</strong>
                              </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default Teamlist;
